module.exports = __webpack_public_path__ + "static/media/tipo-branca.fcc000db.svg";